export const OBJECT = "object";
export const ACCIONES = "acciones";
export const CORREOS = "correos";
export const GEOCERCAS = "geocercas";
export const COLOR = "color";
export const COLOR_A_TIEMPO = "coloratiempo";
export const COLOR_RETRASO = "colorretraso";
export const UBICACION_GPS = "ubicaciongps";
export const CHECK = "check";
export const URL = "url";

export const STRING_DEFAULT_OPCION_RESPUESTA_COLOR = "#d43224";

export const STRING_SIDEBAR_EXPANDED = "SIDEBAR_EXPANDED";
export const STRING_TRUE = "true";
export const STRING_FALSE = "false";

export const STRING_ACCESSTOKEN_PLATAFORMA = "accessTokenPlataforma";
export const STRING_LANGUAGE = "language";
export const STRING_NAME_COMPANY = "nameCompany";
export const STRING_COLOR_COMPANY = "colorCompany";
export const STRING_COLOR_PRIMARIO = "primayColor";
export const STRING_COLOR_SECUNDARIO = "secondaryColor";
export const STRING_URL_LOGO = "urlImage";

export const STRING_PATH_SAVE_FILES = "img-conductor";

export const STRING_CELL_TYPE = {
    CELLCLICKED: "cellClicked",
};

export const STRING_COLUMN_NAME = {
    ACCIONES: "ACCIONES",
    TOTAL_COBRO: "TOTAL COBRO",
    EQUIPOS_ACTIVOS: "EQUIPOS ACTIVOS",
    EQUIPOS_DESACTIVADOS: "EQUIPOS DESACTIVADOS",
};